import { useUpdateAppointmentAdditionalProviderMutation } from "../../../../../../../api/appointments/useUpdateAppointmentAdditionalProviderMutation";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { extractApiError } from "../../../../../../../utilities/api";
import { useContext } from "../context";

export function useUpdateAdditionalProvider() {
  const { tCommon: t } = useAppTranslation.Common();
  const { appointment } = useContext();

  const { mutateAsync, isLoading } =
    useUpdateAppointmentAdditionalProviderMutation({
      onError: (res) => {
        const message = extractApiError(res);
        uiNotification.error(
          t(
            `event.apiError.${message}`,
            "Unable to update additional provider. Try again later.",
          ),
        );
      },
      onSuccess: () => {
        uiNotification.success("Additional provider updated successfully.");
      },
    });

  return {
    initiate: ({ providerId }) => {
      return mutateAsync({
        appointmentId: appointment.id,
        providerId: Number(providerId),
      });
    },
    isLoading,
  };
}
